import React, { useEffect, useState } from 'react';
import './Urgent.css';
import Carousel from 'react-elastic-carousel';
import Image1 from '../NewDonation/NewDonationImages/1.jpg'
import Uang from '../Cards/CardsImages/uang.png'
import Progress from '../Progress Bar/progressbar'
import axios from 'axios';


export default function Carousel1() {

    const [card, setCard] = useState([])

    const fetchCard = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/urgent'
        )
        setCard(data.data)
        console.log(data.data)
    }

    useEffect(() => {
        fetchCard()
    }, [])

    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 500, itemsToShow: 1 },
        { width: 768, itemsToShow: 2 },
        { width: 1200, itemsToShow: 3 },
    ];

    return (
        // <div className="carousel1" breakPoints={breakPoints} >
        <Carousel breakPoints={breakPoints}>
            {card.map(c => (
                <div className="card">
                    <div className="urgent-card-wrapper" key={c.id}>
                        <div className="urgent-card-column">
                            <img src={c.image} alt="" width="100%" height="132" />
                            <h5 className="card-title-1">{c.donationName}</h5>
                            <Progress done="60" />
                        </div>
                        <div className="urgent-card-row">
                            <img className="icon1" src={Uang} alt="" width="70" height="70" />
                            <div className="icon1-column">
                                <p className="icon-txt">Terkumpul<br /><span className="bold-style">{c.donationNeeded}</span></p>
                            </div>
                            <div className="icon2-column">
                                <p className="icon-txt2">Sisa hari<br /><span className="bold-style">{c.expiredDate}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
        // </div>
    )
}
